// /* global d3 $ */
//import pipeService from '../../service/pipeService.js'
import DrawVideo from "./drawVideo.js"
import dataService from "../../service/dataService.js"
import pipeService from "../../service/pipeService.js";

export default {
  name: "VideoDetail",
  components: {},
  props: {
  },
  data() {
    return {
      videoUrl: "video1/0/clip1-0-1.mp4",  
    };
  },
  computed: {
  },
  watch: {
   
  },
  mounted: function() {
    const _this = this;
    _this.drawVideo = new DrawVideo('#labelsContainer');
    let videoPath = _this.videoUrl;
    let videoInfo = {
        "videoWidth": 640,
        "videoHeight": 360,
        "fps": 29.97002997002997,
        "videoPath": videoPath,
        "type": "mp4",
        "start": 0.0,
        "end":0.1,
    };

    pipeService.onVideoEvent(function(videoData){
        console.log("video data: ", videoData);
        videoInfo.start = videoData.start;
        videoInfo.end = videoData.end;
        let videoUrl = window.location.href + `test_mosei/${videoData.videoname}.mp4`
        // `${dataService.dataServerUrl}/video/${videoData.videoname}`
        _this.drawVideo.layout('#labelsContainer', videoInfo, videoUrl);
    });
  }
};